import pic_01_Me_at_the_zoo from './Assets/pic_01_Me_at_the_zoo.webp';
import pic_02_Before_Selfies_Existed from './Assets/pic_02_Before_Selfies_Existed.webp';
import pic_03_Beauty_YouTuber_Look_Hot_in_5_Minutes_or_Less from './Assets/pic_03_Beauty_YouTuber_Look_Hot_in_5_Minutes_or_Less.webp';
import pic_04_The_Golden_Age_of_Vlogging from './Assets/pic_04_The_Golden_Age_of_Vlogging.webp';
import pic_05_Shoutout_to_Our_Vlogging_Hero_Mr_Beast from './Assets/pic_05_Shoutout_to_Our_Vlogging_Hero_Mr_Beast.webp';
import pic_06_Buttons_Silver_Gold_and_Ruby from './Assets/pic_06_Buttons_Silver,_Gold_and_Ruby.webp';
import pic_07_Race_to_the_First_10_Million_Subscribers from './Assets/pic_07_Race_to_the_First_10_Million_Subscribers.webp';
import pic_08_YouTube_Live_FIFA_World_Cup_and_SpaceX from './Assets/pic_08_YouTube_Live_FIFA_World_Cup_and_SpaceX.webp';
import pic_09_The_Soaring_Popularity_of_Game_Streaming from './Assets/pic_09_The_Soaring_Popularity_of_Game_Streaming.webp';
import pic_10_De_spa_cito_amigos from './Assets/pic_10_De-spa-cito,_amigos.webp';
import pic_11_The_Rise_of_Kids_Content from './Assets/pic_11_The_Rise_of_Kids’_Content_.webp';
import pic_12_The_Age_of_Mutual_Respect from './Assets/pic_12_The_Age_of_Mutual_Respect.webp';
import pic_13_Shorts_vs_TikTok_vs_Reels from './Assets/pic_13_Shorts_vs_TikTok_vs_Reels.webp';
import pic_14_Ronaldo_Breaks_YouTube_Record from './Assets/pic_14_Ronaldo_Breaks_YouTube_Record.webp';
import ambassador_pic from './Assets/ambassador.webp';

// export const ambassador = {
//   name: 'West Jett',
//   position: 'right',
//   description: <>
//     <p>
//       What began as a passion project during the height of the COVID-19 lockdown rapidly evolved into a central focus of my life, ultimately surpassing my original career path. I made the decision to step away from my university business studies to explore the potential of this endeavor, and the results have been incredibly rewarding. Developing a dedicated and engaged audience has been a gratifying experience that still feels somewhat surreal, and I feel fortunate to be in this position. What initially started as a gaming and news channel has transformed into a "personality-driven" platform, something I take great pride in. Producing YouTube commentary and reaction content on topics I am passionate about and witnessing the growth of my viewership has been both exciting and fulfilling.
//     </p>
//   </>,
//   image: ambassador_pic,
//   socialLinks: {
//     instagram: 'https://www.instagram.com/westjett/',
//     youtube: 'https://www.youtube.com/@westjett',
//     twitter: 'https://twitter.com/westjett',
//   },
// };

export const ambassador = {
  name: '',
  description: '',
  image: '',
  socialLinks: {
    instagram: 'javascript:void(0)',
    youtube: 'javascript:void(0)',
    twitter: 'javascript:void(0)',
    tiktok: 'javascript:void(0)',
  },
};

export const EpochInfo = {
  title: 'YOUTUBISM',
  period: '2005 - present',
  description: <>
    <p>Youtubism represents a vibrant aspect of contemporary digital video culture, where creators capture both the ordinary and extraordinary in a variety of styles. This movement has transformed everyday life into compelling narratives, turning simple moments into captivating videos.</p>
    <p>What sets Youtubism apart is the rise of a diverse community of vloggers who film their lives anywhere—from parks and high-rise apartments to schools and shopping centers. This trend has popularized the concept of 'vlogging' and embraced a culture where viewers can openly express their opinions, including the option to 'dislike' videos.</p>
    <p>Initially, Youtubism provided a platform for everyday people, often outside the realm of professional media, to showcase their talents and connect with a global audience. Today, this dynamic movement continues to evolve, positioning itself at the forefront of mass media and redefining how we engage with digital content.</p>
  </>,
};

export const events = [
  {
    year: '2005',
    title: 'Me at the zoo',
    content: (
      <>
        <p>The story of Youtubism began in April 2005 when Javed Karim, one of YouTube's co-founders, uploaded the very first video to the platform. In this 18-second clip, we see him at the San Diego Zoo, standing next to elephants and playfully commenting on their “really, really long trunks.”</p>
        <p>This simple yet charming video has since garnered over 45 million views, making it a true icon of early YouTube culture. The San Diego Zoo even expressed their delight in a comment, saying they were “honored” to have been a part of this historic moment.</p>
      </>
    ),
    img: pic_01_Me_at_the_zoo,
    blurhash: '|REe3@jFNbSgM|t6I;afjF~Ao2I;X8RkoeaLaefiWVoeRkkCWVWCjGWVbbRkR+e:n%oKWCSgfQs.IpR+RknjxFWVoyj@smNHWVWVn$t6S2t6bHWCV[W;j[n%t6oLs.ofR*R*s:Woafs:oLoLkBWCWqoebHR*s.bHbHa#WC',
    picName: 'pic_01_Me_at_the_zoo',
  },
  {
    year: '2006',
    title: 'Before Selfies Existed',
    content: (
      <>
        <p>Interest in YouTube skyrocketed when a wave of bloggers began sharing their lives on the platform. Among them was Noah Kalina, a New York photographer with a unique project: he had taken a self-portrait every day for several years. As his collection grew, Kalina realized he needed to elevate his project.</p>
        <p>He compiled his daily photos using Windows Movie Maker and enlisted a friend to create an original soundtrack. With a mix of excitement and nerves, he finally uploaded the video to YouTube.</p>
        <p>On August 27, 2006, the world was introduced to a video that would go viral, inspiring countless parodies and imitations.</p>
      </>
    ),
    img: pic_02_Before_Selfies_Existed,
    blurhash: '|9ELBJnl00rXyC%3IU$i^QuiR,00Rj^,t8rWaKt71Nt7D~ad%NE#nNELFIESS~-6awJBn,RjjEWYajNyNGr=X8oeNdj]r[tS$jWBIpr@baR,ozSeVtslt7xFJ,xGRjaexZR*xGxGxGofsow^s:NbozspsSS2RQoI$*oeRj',
    picName: 'pic_02_Before_Selfies_Existed',
  },
  {
    year: '2006',
    title: 'Beauty YouTuber: Look Hot in 5 Minutes or Less',
    content: (
      <>
        <p>As YouTube took off, we started seeing all sorts of new video topics and categories of bloggers, with beauty bloggers and their makeup tutorials really shining through.</p>
        <p>The first notable video in this genre is “Makeup Lessons – LOOK HOT in 5 Minutes or Less,” uploaded on March 29, 2006. This tutorial focuses on quick makeup techniques and runs for 3 minutes and 51 seconds.</p>
        <p>Though Adrienne K. Nelson’s channel went silent after just four videos, creators like Michelle Phan, Lauren Luke, Marlena Stell, and NikkieTutorials emerged as the true pioneers of YouTube’s beauty community.</p>
      </>
    ),
    img: pic_03_Beauty_YouTuber_Look_Hot_in_5_Minutes_or_Less,
    blurhash: ':BCF|z9G00-Us.o#Rjt7-Pxv9Gs,xvoLRkIo~pIVNHoJE1ogxat7R%s:ahozM|WBxtWCs+aeNHkW-VNGS4sntRs:RkNGn$fkj@t7RjayWCt7s:WAf+aextj[RjWBofaeofkC',
    picName: 'pic_03_Beauty_YouTuber_Look_Hot_in_5_Minutes_or_Less',
  },
  {
    year: '2009',
    title: 'The Golden Age of Vlogging',
    content: (
      <>
        <p>YouTube quickly recognized that vloggers and creators needed active support and inspiration from the platform. In response, the following year, they rolled out video monetization tools, encouraging creators to elevate the quality of their content and use YouTube as a viable income source.</p>
        <p>This marked the dawn of YouTube's golden age of vlogging, where video bloggers transformed into celebrities.</p>
        <p>A great example of this change is Justin Bieber, who went from just an everyday kid to a global superstar, all because of the platform. Baby, baby, baby, ohh!</p>
      </>
    ),
    img: pic_04_The_Golden_Age_of_Vlogging,
    blurhash: '|271N2xt00nO_2-V4:0zni~AJ85RM|nPxaoeR*={8_X8.7jID%Rk-:tQ%1?GW.nj$*NxNGRkxuIoJ:IpIBRjtRofem-nxtWE%2w]aKS3kXoLIUbvIpIp-pxtELn$xaWBRj9aD*%2x[NGad%1%MNGRj$%$*xtoeIpRkIqNd',
    picName: 'pic_04_The_Golden_Age_of_Vlogging',
  },
  {
    year: '2010',
    title: 'Shoutout to Our Vlogging Hero, Mr. Beast',
    content: (
      <>
        <p>Back in the early 2010s, smartphones took off, and suddenly, everyone was jumping into video blogging. It was super easy to whip up a video and toss it up on YouTube, making vlogging more popular than ever. This new way of sharing life led to tons of bloggers showing off their daily routines and adventures.</p>
        <p>We’d like to give a shoutout to Mr. Beast, who’s not only the most famous vlogger but also the highest earner in the game, pulling in a whopping $54 million in 2021, according to Forbes. He might have joined YouTube a bit later in 2012, but he’s become the ultimate example of what vlogging is all about, inspiring so many others to share their stories.</p>
      </>
    ),
    img: pic_05_Shoutout_to_Our_Vlogging_Hero_Mr_Beast,
    blurhash: '|IG~-5}@}HJ6$,XSOAofS}h|IW#TJARPnNR*aeR*K$OWJ6n$XmtQxuozxD$jxstQxHIoRRnOr?jbspRkR6M{oIs,ofofW;NGbHxu%2S}kVt7X7axo#jZaKrtRjI:V[jFsVRko3xGSgWBWVkAs.bHoebHW=oeXRodofS5ay',
    picName: 'pic_05_Shoutout_to_Our_Vlogging_Hero,_Mr_Beast',
  },
  {
    year: '2012',
    title: 'Buttons: Silver, Gold and Ruby',
    content: (
      <>
        <p>When it comes to iconic vloggers, YouTube set a remarkable precedent in 2012 by introducing a unique way to honor standout creators with massive audiences: the special play buttons.</p>
        <p>The Silver Play Button celebrates channels that hit the milestone of 100,000 subscribers, while the Gold Play Button is reserved for those who reach a million. These awards quickly became symbols of success and recognition within the YouTube community.</p>
        <p>The Ruby Play Button is earned once an eligible channel achieves 50 million followers, and to date, about 9 channels have received this prestigious award. This rare accolade exemplifies the pinnacle of YouTube fame!</p>
      </>
    ),
    img: pic_06_Buttons_Silver_Gold_and_Ruby,
    blurhash: '|ZHd?3%L4pRPM{RlkXs;RjA0RkRiX9xaoyt6k8V@~V%2IURPRkWCozogRko2a_V[W=tQoLNGn%oyS$j]RjadoLbFoLWrs:slocoeWYR.j[j?oJozt7WCNGoet6a|R+WCofoyf7WBj@WCbHt6a{fSjaj@oKj[WWWCWVjtof',
    picName: 'pic_06_Buttons_Silver,_Gold_and_Ruby',
  },
  {
    year: '2013',
    title: 'Race to the First 10 Million Subscribers',
    content: (
      <>
        <p>No discussion about subscriber milestones would be complete without mentioning Smosh. This iconic American sketch comedy YouTube channel was launched in 2005 by Anthony Padilla and Ian Hecox.</p>
        <p>In a thrilling twist, Smosh raced ahead of PewDiePie to become the first channel to hit 10 million subscribers, achieving this impressive feat in May 2013 — just two months after reaching the milestone. Although PewDiePie eventually reclaimed the title in August, Smosh's historic achievement ensures they’ll always be remembered as pioneers in the YouTube community.</p>
        <p>And let’s be real — PewDiePie, boasting an incredible 111 million subscribers, is probably not losing any sleep over that old race to 10 million!</p>
      </>
    ),
    img: pic_07_Race_to_the_First_10_Million_Subscribers,
    blurhash: '|AEexmo|0Mm-M|o|IVRk%L4;NHnikVt5aKxsoyNH0#of-ASzxtwJf*WVR-=xbvNuwJRkW;azayRkMzNIbaw^xZW:oeofWC~oxFD+I;WXs:M|RktRIVt6ays:e.n%xskCWCxaX8SfV@oJofWCWVoMIpafs:NHjZaejFs.S4',
    picName: 'pic_07_Race_to_the_First_10_Million_Subscribers',
  },
  {
    year: '2013',
    title: 'YouTube Live: FIFA World Cup and SpaceX',
    content: (
      <>
        <p>In August 2013, YouTube launched its YouTube Live service, allowing users to stream live in real time. Today, this feature is still highly relevant. For example, the SpaceX live stream in 2020 set a record for the number of views on YouTube.</p>
        <p>That record didn’t last long, though. It was broken twice during the FIFA World Cup Qatar 2022, thanks to Brazilian streamer and journalist Casimiro, whose live streams peaked at over 6.1 million viewers during the Brazil–Croatia match.</p>
        <p>Imagine the FIFA World Cup on Mars. How will viewers and Elon Musk react to this extraordinary event?</p>
      </>
    ),
    img: pic_08_YouTube_Live_FIFA_World_Cup_and_SpaceX,
    blurhash: '|9A0?wV@00J7.7WZMxs+t8%$s:IAR-xuj@RjjZoz01oz?YwwMyoHofS4f54-Rk?I$|IoV[ozbbRPMce.%MS#IpR+xuoLR+V#ocxnNKRRg3n$jFoz?YWB9coL%0t7RkWBWC~3bc4=s,%0s.R+aeWYD+t7%KRjV@WUWAj[s+',
    picName: 'pic_08_YouTube_Live_FIFA_World_Cup_and_SpaceX',
  },
  {
    year: '2015',
    title: 'The Soaring Popularity of Game Streaming',
    content: (
      <>
        <p>With the rise of live streaming, it quickly became evident that this format was exactly what many viewers, especially gamers, had been craving.</p>
        <p>In response to Google's acquisition of Twitch, YouTube stepped up with its own game streaming service, YouTube Gaming. By 2018, YouTube seamlessly integrated YouTube Gaming into its main platform, making streaming even more accessible for users.</p>
        <p>Impressive stats: as of mid-2022, YouTube Gaming Live boasted over 443,000 unique streaming channels, showcasing the immense popularity of live gaming content.</p>
      </>
    ),
    img: pic_09_The_Soaring_Popularity_of_Game_Streaming,
    blurhash: '|BB2}+^mEkACIo-U#8m+Rj}]t8NZIobXxGepnjRjMdMxR$NYSwX8tSxvNwEMNGoIt4WAW=xut8OEF3XTxv-U$PM|V?V[smOXoft8%2sBNFRiV?xCskjpNGWFW?SNoyodoI$%s+V[RnX9XSg2ofoMtPaesCsXsqX8Nan%j]',
    picName: 'pic_09_The_Soaring_Popularity_of_Game_Streaming',
  },
  {
    year: '2017',
    title: 'De-spa-cito, amigos!',
    content: (
      <>
        <p>A Quick Detour!</p>
        <p>We hope you enjoy this song and that it lingers in your mind for a while because it’s bound to stick with you!</p>
        <p>Back in 2017, YouTube sensation and singer Luis Fonsi dropped a track that took the world by storm. Its incredible popularity has kept it firmly in the spotlight, making it the second most-watched video on YouTube to this day.</p>
      </>
    ),
    img: pic_10_De_spa_cito_amigos,
    blurhash: '|REn@S%LE2R6Iosms.R+xZ~UxtIpVsRjfkbHWCs:gMs:V[jFn$NaR*oLkCkVbHRkoejuWBn$s:kCbHofR-j[ayR*axayfkxZt7ofayWBRjjFR*WCxaofbHWCWBV@jYbHa}R+bHs:jZaeWBWCoLj[NHWBs.oeoJj@ayoJWW',
    picName: 'pic_10_De-spa-cito,_amigos!',
  },
  {
    year: '2018',
    title: 'The Rise of Kids’ Content',
    content: (
      <>
        <p>In 2018, kids’ content took off on YouTube, bringing fame and significant earnings to creators. However, this growth came with stricter anti-hate policies, leading to a ban on comments for kids' videos. Here are some notable Kid YouTubers:</p>
        <p>Like Nastya: At just eight years old, Nastya's channel has nearly 105 million subscribers and started as a toy review blog. In 2021, she and her family made an impressive $28 million, according to Forbes.</p>
        <p>Ryan’s World: Ryan Kaji, runs the most popular channel for toy reviews. His mix of reviews, educational videos, and family content earned him $27 million in 2021.</p>
        <p>EvanTubeHD: Although Evan is no longer a kid, his impact on kids' content is significant. He still runs his channel and has shared his experiences growing up as a Kid YouTuber in interviews.</p>
        <p>This era of children's content has transformed YouTube and continues to inspire new creators.</p>
      </>
    ),
    img: pic_11_The_Rise_of_Kids_Content,
    blurhash: '|BDtn{KY0#|z%B=h9@ElEg-;s7E1s?tLt8v~NENJ9@JEACI:RpR}-Doa$*55w~={S0NNNYxaj]OA0x=f^PJ#eZNYt6f-NtIoR*xbNsj0jGbW-CR$R:NZxHS1NFsFSv$+R+Sgs,xGSOR%xIX4S0r^OTs:oLJ6oMs:W=V[WB',
    picName: 'pic_11_The_Rise_of_Kids’_Content_',
  },
  {
    year: '2021',
    title: 'The Age of Mutual Respect',
    content: (
      <>
        <p>In 2021, YouTube's announcement to hide Dislikes took many by surprise. While some viewed it as a setback, the decision aimed to foster a safer environment for creators, as developers believed that an abundance of Dislikes could be seen as a form of bullying.</p>
        <p>We want to express our gratitude to the developers who stepped up by creating an innovative browser extension that resurrects YouTube Dislikes, allowing users to express their opinions once more. A Like to Dislike?</p>
      </>
    ),
    img: pic_12_The_Age_of_Mutual_Respect,
    blurhash: '|8I}CMnR3p9tl;;jE2?[jcxWNbD*-p%LV@S~9aVZ0OI::7,H*HcDozVZwI01n*yCE2WCnlw]n$g2+wjGAaSdM}a1IBNGx[57oz#+IVI=x[xtxYE3Sxofs9jaNcNbxa%LNHx[aynOWWE2xtaeNHs.9btQ-:t6M|SgsmxtR*',
    picName: 'pic_12_The_Age_of_Mutual_Respect',
  },
  {
    year: '2021',
    title: 'Shorts vs. TikTok vs. Reels',
    content: (
      <>
        <p>YouTube Shorts, launched in the U.S. in 2021, is the platform's answer to the rising trend of short-form video content. These bite-sized vertical videos, lasting up to 60 seconds, cater to the growing demand for quick, engaging clips that have taken platforms like TikTok by storm.</p>
        <p>While it’s still too early to tell if any bloggers have skyrocketed to celebrity status through YouTube Shorts, it’s undeniable that Shorts offer a compelling alternative to TikTok and Reels, providing creators with an exciting new way to connect with their audience.</p>
      </>
    ),
    img: pic_13_Shorts_vs_TikTok_vs_Reels,
    blurhash: '|7KSbI00Q8~paPD*Eh%2D$p{z:0e$%OpNHXTjFZ~@_%M9@EMXn%L-TRQi{0NkW,,NeXBxWobNdR+u+s.P9rr%LaLNGS2ozA9S#pJSg#kj]RP$yogUbxupwVsM_SiV@fitlK0bIxFayW=jFVtt7xuDQt5x]W?NFaKkCtQso',
    picName: 'pic_13_Shorts_vs_TikTok_vs_Reels',
  },
  {
    year: '2024',
    title: 'Ronaldo Breaks YouTube Record',
    content: (
      <>
        <p>Cristiano Ronaldo's YouTube channel hit one million subscribers just 90 minutes after his first video on August 21, setting a platform record. Two days later, he surpassed 30 million subscribers.</p>
        <p>He’s also the first person to reach one billion total followers across Instagram, Facebook, Twitter, YouTube, and Chinese platforms Weibo and Kuaishou.</p>
      </>
    ),
    img: pic_14_Ronaldo_Breaks_YouTube_Record,
    blurhash: '|LJ7K,oINxxtnioyS$S4OYDjt6xtn$xZX7R,ozbv~paen$aetQs.WBW;aKM|s9xZWWNGkCxts.jZS2ae$iNbbvWCWBxFWVofRQniNHIpSNkBaeNHMys9RkNHS5NbofW;WV%1RkShX8t7oenhjYaeS5Wrn%WBRjoJxZoLWB',
    picName: 'pic_14_Ronaldo_Breaks_YouTube_Record',
  },
];